var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconChangePass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 25.3331C18.9331 25.3331 21.3331 22.9331 21.3331 19.9998C21.3331 17.0532 18.9331 14.6665 15.9998 14.6665C13.0532 14.6665 10.6665 17.0532 10.6665 19.9998C10.6665 22.9331 13.0532 25.3331 15.9998 25.3331Z",
    stroke: "#22BD57",
    strokeWidth: 1.99999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9199 20L14.7866 20.8667C15.0399 21.12 15.4532 21.1333 15.7066 20.88L18.0799 18.6934",
    stroke: "#22BD57",
    strokeWidth: 1.99999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 29.3331H20C25.3599 29.3331 26.3199 27.1864 26.5999 24.5731L27.5999 16.5731C27.9599 13.3198 27.0266 10.6665 21.3333 10.6665H10.6667C4.97334 10.6665 4.04001 13.3198 4.40001 16.5731L5.40001 24.5731C5.68001 27.1864 6.64 29.3331 12 29.3331Z",
    stroke: "#22BD57",
    strokeWidth: 1.99999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.2266V8.93332C10 5.93333 12.4133 2.98668 15.4133 2.70668C18.9866 2.36001 22 5.17333 22 8.67999V10.52",
    stroke: "#22BD57",
    strokeWidth: 1.99999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChangePass);
export default __webpack_public_path__ + "static/media/iconChangePass.09f2247a74c2e59fd90fb253cb82d631.svg";
export { ForwardRef as ReactComponent };